<div
  class="munily-input-preview"
  [ngClass]="containerClasses"
  [attr.role]="clickable ? 'button' : null"
  [attr.tabindex]="clickable ? 0 : null"
  (click)="onClick()"
>
  <!-- Leading icon (opcional) -->
  <mat-icon
    *ngIf="showLeadingIcon"
    class="munily-input-preview__leading-icon material-symbols-rounded"
    aria-hidden="true"
  >{{ leadingIcon }}</mat-icon>

  <!-- Labels: label + value -->
  <div class="munily-input-preview__labels">
    <span *ngIf="showLabel && label" class="munily-input-preview__label">{{ label }}</span>
    <span class="munily-input-preview__value">
      <span *ngIf="valuePrefix" class="munily-input-preview__value-affix">{{ valuePrefix }}</span>
      <span class="munily-input-preview__value-text">{{ value }}</span>
      <span *ngIf="valueSuffix" class="munily-input-preview__value-affix">{{ valueSuffix }}</span>
    </span>
  </div>

  <!-- Edit icon (opcional) -->
  <common-icon-button
    *ngIf="showEditIcon"
    variant="plain"
    icon="edit"
    ariaLabel="Editar"
    iconSet="material-icons-outlined"
    class="munily-input-preview__edit-btn"
    (output)="onEdit()"
  ></common-icon-button>
</div>
